<template>
  <el-tag style="height: auto" type="info">
    {{ infoData.activity.name }} <br />
    {{ $t('common_words.value') }}: ${{ formatNumber(infoData.price) }}
    <br />
    {{ $t('labor.unit') }}: {{ infoData.activity.unit_production_name }} <br />
    {{ $t('common_words.category') }}:
    {{ infoData.activity.group_name }}
  </el-tag>
</template>
<script>
import Formatter from 'src/class/Formatter';

export default {
  name: 'value-activities-info',
  props: {
    infoData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatNumber(value) {
      return Formatter.formatMoney(Number(value));
    },
  },
};
</script>
